module.exports = __webpack_public_path__ + "static/shark-tank-hub-9388abafe786f48699fc23cae83f30a6.jpg";